import { Box } from '@chakra-ui/react';
import { CustomSupportIcon } from '../../theme/icons/CustomSupportIcon';

const PASSENTRY_DOCS_URL = 'https://docs.passentry.com/?assistant=';

const SupportTab = () => (
  <Box
    as="a"
    href={PASSENTRY_DOCS_URL}
    target="_blank"
    rel="noopener noreferrer"
    bg="#243743"
    color="#fff"
    py="5px"
    px="15px"
    pb="7px"
    fontWeight={700}
    fontSize="14px"
    borderTopRadius="5px"
    position="fixed"
    right="-5px"
    bottom="30dvh"
    transform="rotate(-90deg)"
    transformOrigin="bottom right"
    transition="right 0.2s ease-out"
    alignItems="center"
    gap="10px"
    textDecoration="none"
    _hover={{ right: '-2px' }}
    sx={{
      display: 'inline-flex',
      '@media screen and (max-width: 62rem)': {
        display: 'none',
      },
    }}
  >
    <Box
      as="span"
      display="block"
      flexShrink={0}
      lineHeight={0}
      sx={{
        transform: 'rotate(90deg)',
        transformOrigin: 'center',
      }}
    >
      <CustomSupportIcon />
    </Box>
    Support
  </Box>
);

export default SupportTab;
